import { render, staticRenderFns } from "./devWarn.vue?vue&type=template&id=467dcce0&scoped=true&"
import script from "./devWarn.vue?vue&type=script&lang=js&"
export * from "./devWarn.vue?vue&type=script&lang=js&"
import style0 from "./devWarn.vue?vue&type=style&index=0&id=467dcce0&scoped=true&lang=css&"
import style1 from "./devWarn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467dcce0",
  null
  
)

export default component.exports